import script from "./CourseMy.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseMy.vue?vue&type=script&setup=true&lang=ts"

import "./CourseMy.vue?vue&type=style&index=0&id=770ea043&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770ea043"]])

export default __exports__